import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { LanguageProvider } from '@/context/LanguageContext';
import HomePage from '@/pages/HomePage';
import InquiryPage from '@/pages/InquiryPage';
import InquiryConfirmationPage from '@/pages/InquiryConfirmationPage';
import AdminDashboard from '@/pages/AdminDashboard';
import LegalNoticePage from '@/pages/LegalNoticePage';
import PrivacyPolicyPage from '@/pages/PrivacyPolicyPage';
import Layout from '@/components/Layout';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/inquiry" element={<InquiryPage />} />
              <Route path="/inquiry-confirmation" element={<InquiryConfirmationPage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/mentions-legales" element={<LegalNoticePage />} />
              <Route path="/politique-de-confidentialite" element={<PrivacyPolicyPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
        <Toaster position="bottom-right" />
      </LanguageProvider>
    </div>
  );
}

export default App;
